import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initI18n, startLocale } from './lib/i18n';
import './styles/app.css';
import 'hopcharts/styles.css';

// Chrome only records a paint for Largest Contentful Paint once it has reported that paint; text replaced
// before then is dropped, and the app's own later render becomes the page's LCP. So the prerendered page
// stays until its first paint is reported (with a ceiling for hidden tabs, which do not paint).
function firstPaint(): Promise<void> {
  const root = document.getElementById('root');
  if (!root?.hasChildNodes() || !PerformanceObserver.supportedEntryTypes?.includes('paint')) return Promise.resolve();
  return new Promise((resolve) => {
    const observer = new PerformanceObserver((list) => {
      if (list.getEntriesByName('first-contentful-paint').length) done();
    });
    const timer = setTimeout(() => done(), 1000);
    function done() {
      observer.disconnect();
      clearTimeout(timer);
      resolve();
    }
    observer.observe({ type: 'paint', buffered: true });
  });
}

// The language is settled before the first render: the router's basename and the texts depend on it.
const start = startLocale(window.location, document.cookie, navigator.languages ?? []);
if (start.redirect) {
  window.location.replace(start.redirect);
} else {
  void Promise.all([initI18n(start.locale), firstPaint()]).then(() => {
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  });
}
